function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as o } from "react/jsx-runtime";
import { useTheme as i } from "../../hooks.js";
import { useIsInverseVariant as s } from "../../theme-variant-context.js";
import { vars as h } from "../../skins/skin-contract.css-mistica.js";
const a = (_param)=>{
    var { color: t , size: e = 24  } = _param, c = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const n = s(), r = t !== null && t !== void 0 ? t : n ? h.colors.inverse : h.colors.neutralHigh, { skinName: l  } = i();
    return l.match(/^o2/i) ? /* @__PURE__ */ o("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, c), {
        children: /* @__PURE__ */ o("path", {
            fill: r,
            d: "M11.998 2C6.746 2 2.47 6.488 2.47 12v6.248c0 2.139 1.463 3.747 3.401 3.747h1.703V14.5H5.87c-.78 0-1.48.265-2.042.713V12c0-4.726 3.662-8.57 8.165-8.57 4.503 0 8.165 3.844 8.165 8.57v3.213a3.219 3.219 0 00-2.043-.713h-1.702V22h1.702c1.938 0 3.402-1.613 3.402-3.748V12c.008-5.512-4.268-10-9.52-10zM5.875 15.926h.34v4.644h-.34c-1.184 0-2.042-.979-2.042-2.322 0-1.344.858-2.322 2.042-2.322zm11.906 4.644v-4.644h.34c1.184 0 2.042.978 2.042 2.322 0 1.343-.858 2.322-2.042 2.322h-.34z"
        })
    })) : /* @__PURE__ */ o("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, c), {
        children: /* @__PURE__ */ o("path", {
            fill: r,
            d: "M11.895 2.155c5.075 0 7.89 3.196 7.98 9 1.263.655 1.966 2.02 1.97 4 0 2.745-1.331 4.32-3.738 4.431l-.274.009h-.126a.37.37 0 01-.11-.017c-1.21.888-2.775 1.44-4.655 1.636a.994.994 0 01-.176.28c-.241.233-.577.35-.986.35h-.067c-.443-.008-.793-.162-1.029-.417-.232-.255-.341-.614-.324-1.056.025-.92.568-1.415 1.445-1.39.686.017 1.137.359 1.288.93 1.222-.162 2.267-.479 3.135-.963-.667-.742-.843-2.082-.843-3.793 0-2.625.392-4.38 2.339-4.448.092-.009.187-.009.283 0 .036 0 .084 0 .134.008.102.005.196.02.29.034.061.01.123.018.186.025-.193-4.868-2.44-7.339-6.72-7.339-4.28 0-6.53 2.48-6.714 7.364a4.74 4.74 0 01.712-.086c.016-.009.067-.009.117-.009.098-.008.2-.008.3 0 1.907.067 2.308 1.824 2.308 4.448 0 2.617-.4 4.373-2.342 4.44H6.17l-.277-.008c-2.41-.11-3.737-1.687-3.737-4.432 0-1.865.62-3.17 1.765-3.87.047-5.886 2.874-9.127 7.975-9.127zM5.942 11.99c-1.087.042-2.532.425-2.532 3.162 0 2.726 1.445 3.11 2.53 3.163h.231c.543-.02 1.191-.043 1.191-3.163 0-3.13-.65-3.154-1.126-3.17H6.06l-.06.003-.059.004zm12.104 6.325c1.087-.053 2.54-.437 2.546-3.163 0-2.736-1.454-3.117-2.54-3.162l-.11-.009h-.114c-.543.02-1.191.043-1.191 3.171 0 2.499.417 3.011.826 3.13.05 0 .101.008.149.024.05.009.1.009.15.009h.284z"
        })
    }));
}, f = a;
export { f as default };
